import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { GoalRecapRow } from "web_myplann/Inspiration/Components/GoalRecapRow";
import type { InspirationGoalRecapRow } from "web_myplann/Inspiration/Types/InspirationTypes";

type Props = {
	rows: InspirationGoalRecapRow[];
};

export const GoalRecapCard: FC<Props> = ({ rows }) => {
	const theme = useTheme();

	return (
		<Stack
			bgcolor={theme.palette.surface.muted}
			borderRadius={theme.radii.lg}
			p={theme.spacingTokens.md}
			gap={theme.spacingTokens.md}
		>
			{rows.map((row) => (
				<Stack
					key={row.label}
					pt={row.dividerBefore ? theme.spacingTokens.md : 0}
					borderTop={
						row.dividerBefore
							? theme.colors.border.solid(theme.palette.grey[200])
							: undefined
					}
				>
					<GoalRecapRow
						label={row.label}
						note={row.note}
						value={row.value}
						highlight={row.highlight}
					/>
				</Stack>
			))}
		</Stack>
	);
};
